'use strict';

var Marionette = require('backbone.marionette');

var ListView = require('./service-list').default;

var ServiceCategoryEvents = require('../../../analytics/service-selection-events').default;

export default Marionette.View.extend({

  tagName: 'li',
  className: 'category-list-category',
  template: require('./templates/category-list-item.hbs'),
  triggers: {
    'click .category-list-title': 'click:title',
  },
  ui: {
    icon: '.category-list-icon',
    list: '.category-list-services',
  },

  initialize: function (options) {
    this.options = options || {};

    var self = this;
    this.listView = new ListView({
      appointment: options.appointment,
      collection: this.collection,
      filter: function (child, index, collection) {
        return child.hasCategory(self.model);
      },
    });

    this.listenTo(this.listView, 'childview:click:checkbox', this.onClickCheckbox);
  },

  onRender: function () {
    this.ui.list.append(this.listView.render().el);

    ServiceCategoryEvents.trackShow('Category');
  },

  onDomRefresh: function () {
    if (this.options.defaultOpen) {
      this.ui.icon.addClass('open');
      this.ui.icon.attr('aria-expanded', 'true');
      this.ui.list.show();
    }
  },

  onClickCheckbox: function (view) {
    this.trigger('click:service', view);
  },

  isCollapsable: function () {
    return this.ui.icon.is(':visible');
  },

  toggle: function () {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  },

  isOpen: function () {
    return this.ui.icon.hasClass('open');
  },

  open: function () {
    ServiceCategoryEvents.trackOpen('Category');
    this.ui.icon.addClass('open');
    this.ui.icon.attr('aria-expanded', 'true');
    this.ui.list.slideDown('slow');
  },

  close: function () {
    ServiceCategoryEvents.trackClose('Category');
    this.ui.icon.removeClass('open');
    this.ui.icon.attr('aria-expanded', 'false');
    this.ui.list.slideUp('slow');
  },

});
